import React, { useState } from "react";
import { Share2, Check, Copy, X } from "lucide-react";
import { toast } from "sonner";

const SHARE_URL = "https://oweverit.com";
const SHARE_TEXT = "I'm using OWEverit to pay off my debt faster — snowball/avalanche plans, cash-flow forecasts and more. Every balance, gone.";

export default function ShareCTA() {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const url = typeof window !== "undefined" ? window.location.origin : SHARE_URL;

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "OWEverit", text: SHARE_TEXT, url }); return; } catch { /* cancelled */ return; }
    }
    setOpen(o => !o);
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(`${SHARE_TEXT} ${url}`); setCopied(true); toast.success("Link copied — thanks for sharing!"); setTimeout(() => setCopied(false), 1500); } catch {}
  };

  const enc = encodeURIComponent;
  const socials = [
    { name: "X", href: `https://twitter.com/intent/tweet?text=${enc(SHARE_TEXT)}&url=${enc(url)}`, label: "𝕏" },
    { name: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`, label: "f" },
    { name: "WhatsApp", href: `https://wa.me/?text=${enc(SHARE_TEXT + " " + url)}`, label: "✆" },
    { name: "Reddit", href: `https://www.reddit.com/submit?url=${enc(url)}&title=${enc("OWEverit — every balance, zeroed")}`, label: "r/" },
  ];

  return (
    <div className="relative" data-testid="share-cta">
      <button onClick={nativeShare} data-testid="share-cta-btn"
        className="w-full flex items-center gap-2 px-3 py-2.5 rounded-xl border border-teal-500/30 bg-gradient-to-r from-teal-500/10 to-indigo-500/10 hover:from-teal-500/20 hover:to-indigo-500/20 transition text-left">
        <span className="h-8 w-8 rounded-lg bg-teal-500/20 text-teal-500 flex items-center justify-center shrink-0"><Share2 className="h-4 w-4" /></span>
        <span className="min-w-0">
          <span className="block text-xs font-semibold">Love OWEverit? Share it</span>
          <span className="block text-[10px] text-muted-foreground">Help a friend get debt-free too</span>
        </span>
      </button>

      {open && (
        <div className="absolute bottom-full left-0 right-0 mb-2 p-3 rounded-xl border border-border bg-card shadow-xl z-40" data-testid="share-cta-menu">
          <div className="flex items-center justify-between mb-2">
            <span className="text-[10px] uppercase tracking-wider font-semibold text-muted-foreground">Share OWEverit</span>
            <button onClick={() => setOpen(false)} className="p-0.5 rounded hover:bg-accent text-muted-foreground"><X className="h-3.5 w-3.5" /></button>
          </div>
          <div className="grid grid-cols-4 gap-1.5">
            {socials.map(s => (
              <a key={s.name} href={s.href} target="_blank" rel="noreferrer" title={`Share on ${s.name}`} data-testid={`share-${s.name.toLowerCase()}`}
                className="h-9 rounded-lg bg-accent hover:bg-accent/70 flex items-center justify-center text-sm font-bold transition">{s.label}</a>
            ))}
          </div>
          <button onClick={copy} data-testid="share-copy-btn"
            className="mt-2 w-full flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg border border-border text-xs font-semibold hover:bg-accent transition">
            {copied ? <><Check className="h-3.5 w-3.5 text-emerald-500" /> Copied</> : <><Copy className="h-3.5 w-3.5" /> Copy link</>}
          </button>
        </div>
      )}
    </div>
  );
}
